import React, { createContext, useContext, useState } from "react";
import { AppRoutes } from "utils/routes";
import { useSelector } from "react-redux";;

type ModalProviderPropsType = {
  children: React.ReactNode;
};

type ModalStateType = {
  isOpen: boolean;
  showModal: (payload?: any) => void;
  hideModal: () => void;
  modalData: any;
  isMenuOpen: Boolean;
  handleMenu: () => void;
  seturl: any;
  urlDtails: any;
  setUrlDtails: any;
  url: number;
  setIsmenuOpen: any;
  isExpanded: Boolean;
  setisExpanded: any;
  currentPage: null | string;
  setcurrentPage: any;
  timelinBarBagroundColor: any;
  setTimelinBarBagroundColor: any;
};

export const ModalContext = createContext<ModalStateType | undefined>(
  undefined
);

const ModalProvider = ({ children }: ModalProviderPropsType) => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalData, setModalData] = useState(null);
  const [currentPage, setcurrentPage] = useState(null);
  const [isMenuOpen, setIsmenuOpen] = useState(false);
  const [isExpanded, setisExpanded] = useState(false);
  const [timelinBarBagroundColor, setTimelinBarBagroundColor] = useState("");
  const  {activeEventCardData }  =  useSelector((store: any) => store.keyEvents);
console.log(activeEventCardData.year_title,AppRoutes.events(activeEventCardData.year_title),"sagar")

  const [urlDtails, setUrlDtails] = useState<any>([

    "/",
    "/keyevents",
    `${AppRoutes.events(activeEventCardData.year_title)}`,
  ]);

  const [url, seturl] = useState(0);
  const showModal = (payload?: any) => {
    setModalData(() => payload);
    setIsOpen(true);
  };

  const hideModal = () => {
    setIsOpen(false);
  };

  const handleMenu = () => {
    setIsmenuOpen(!isMenuOpen);
  };

  return (
    <ModalContext.Provider
      value={{
        isOpen,
        showModal,
        hideModal,
        modalData,
        isMenuOpen,
        handleMenu,
        urlDtails,
        setUrlDtails,
        seturl,
        url,
        isExpanded,
        setisExpanded,
        setIsmenuOpen,
        currentPage,
        setcurrentPage,
        timelinBarBagroundColor , setTimelinBarBagroundColor
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

function useModal() {
  const context = useContext(ModalContext);

  if (context === undefined) {
    throw new Error("useModal must be used within a ModalProvider");
  }

  return context;
}

export { ModalProvider, useModal };
